import Link from 'next/link';
import { useRouter } from 'next/router';
import React from 'react';
import { useTranslation } from 'next-i18next';
import { getClassName } from '../../../nav-helpr';
import appUtils from '../../../../../../utils/appUtils';

const GuestHeaderDesktopLeftPart = () => {
  const { t } = useTranslation('common');
  const { pathname: currentPath } = useRouter();
  const router = useRouter();
  const { locale: currentLocale } = router;
  return (
    <div className="hidden md:ml-6 md:flex md:space-x-8">
      <Link
        href={`/school/learn-spoken-english`}
        className="text-default inline-flex items-center px-1 pt-1 text-sm font-medium"
      >
        {t('service.header.school')}
      </Link>
      <a
        className={getClassName('/tutors', currentPath)}
        href={appUtils.getAppPath(currentLocale, 'tutors')}
      >
        {t('service.header.tutors')}
      </a>
      <Link
        href={`/courses`}
        className="text-default inline-flex items-center px-1 pt-1 text-sm font-medium"
      >
        {t('service.header.courses')}
      </Link>
      <Link
        href={`/pricing`}
        className="text-default inline-flex items-center px-1 pt-1 text-sm font-medium"
      >
        {t('service.header.pricing')}
      </Link>
    </div>
  );
};

export default GuestHeaderDesktopLeftPart;
